"use es6";

const isMotionValue = value => Boolean(value && value.getVelocity);
export { isMotionValue };